module.exports = __webpack_public_path__ + "static/media/dorp.1dfeb150.jpg";